import { useState } from 'react'
import { DownloadExcelResumeRequest } from '@/api/rentals/request.types.ts'
import { useRentalsApiClient } from '@/api/rentals/useRentalsApiClient.ts'
import { useDownloadExcelFile } from '@/presentation/common/hooks/crud/v2/useDownloadExcelFile.ts'

export const useDownloadRentalsExcel = () => {
  const repository = useRentalsApiClient()
  const query = useDownloadExcelFile<DownloadExcelResumeRequest>({
    filename : 'rentals.xlsx',
    callable : repository.downloadExcelResume,
    messages : {
      default : 'Error al generar archivo',
      loading : 'Generando archivo',
      success : 'Archivo generado',
    },
  })

  const [ data, setData ] = useState<File>()

  const submit = async (req: DownloadExcelResumeRequest) => {
    const response = await query.submit(req)
    setData(response)
  }

  return {
    ...query,
    submit,
    data,
  }
}
